exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".infoBox___jslLd {\n  margin: 1rem 0rem;\n  background-color: #cde7f2;\n  padding: 1rem;\n}\n", "", {"version":3,"sources":["/./studio/studio/ShareModal.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;CACf","file":"ShareModal.scss","sourcesContent":[".infoBox {\n  margin: 1rem 0rem;\n  background-color: #cde7f2;\n  padding: 1rem;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"infoBox": "infoBox___jslLd"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=2&sourceMap&localIdentName=[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader?outputStyle=expanded&sourceMap!./studio/ShareModal.scss
 ** module id = 5
 ** module chunks = 0
 **/